import { combineReducers } from 'redux'
import BonusPointsReducer from './bonus.points.reducer'
import BonusSettingsReducer from './bonus.settings.reducer'

const BonusReducer = combineReducers({
  settings: BonusSettingsReducer,
  points: BonusPointsReducer,
})

export default BonusReducer